export const localization = {
    pt: {
        title: 'Falha ao carregar',
        subtitle: 'Tente novamente ou verifique sua conexão.',
        tryAgain: 'Tentar novamente',
    },
    en: {
        title: 'Load Error',
        subtitle: 'Try again or check your connection.',
        tryAgain: 'Try Again',
    },
    es: {
        title: 'Error de carga',
        subtitle: 'Inténtalo de nuevo o verifica tu conexión.',
        tryAgain: 'Intentar de nuevo',
    },
  };
  